export default "__VITE_ASSET__DmGZ5ieN__"